import { memo } from 'react';

import type { SVGProps } from 'react';
const SvgImageRibbonValidated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 85"
    role="img"
    className={props.className}
    {...props}
  >
    <path
      fill="#F4F6F7"
      stroke="#E2E8EB"
      d="M7.27.467h26.344a.5.5 0 0 1 .5.5v82.42a.5.5 0 0 1-.722.448l-12.284-6.096a1.5 1.5 0 0 0-1.334 0L7.492 83.835a.5.5 0 0 1-.722-.448V.967a.5.5 0 0 1 .5-.5Z"
    />
    <path fill="#fff" d="M4.602 27c0-8.837 7.163-16 16-16s16 7.163 16 16-7.164 16-16 16-16-7.163-16-16" />
    <circle cx={20.602} cy={27} r={16.5} fill="#C88245" stroke="#904C06" />
    <path fill="#C3782C" d="M20.602 43c8.836 0 16-7.163 16-16s-7.164-16-16-16z" />
    <path
      stroke="#914C06"
      d="M30.2 24.502 20.6 17.4 11 24.24v5.26m19.2-4.997v5.26L20.6 36.6 11 29.5m19.2-4.997-9.6 7.101-6.309-4.629M11 29.5l3.291-2.525m12.892-.105L20.6 22.135l-6.309 4.84"
    />
    <circle
      cx={20.602}
      cy={27}
      r={20}
      stroke="#C88245"
      strokeDasharray="0.83 3.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
    />
  </svg>
);
const Memo = memo(SvgImageRibbonValidated);
export default Memo;
